
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleeth as ObiSleethElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleeth.js';
 
 
 

 
 export const ObiSleeth = createComponent({
   react: React,
   tagName: 'obi-sleeth',
   elementClass: ObiSleethElement,
   events: {
     
   }
  });
 
 